import script from "./TechnologyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyView.vue?vue&type=script&setup=true&lang=ts"

import "./TechnologyView.vue?vue&type=style&index=0&id=75f57b9b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f57b9b"]])

export default __exports__